<template>
  <div
    class="group flex items-center gap-2 px-3 py-2 border-b border-slate-700 hover:bg-slate-700/30 cursor-pointer transition-colors"
    @click="$emit('select')"
  >
    <div
      v-if="idLabel"
      class="flex-shrink-0 font-mono font-bold text-xs text-cyan-300 bg-slate-700 rounded px-1.5 py-0.5"
      title="Runtime ID"
    >{{ idLabel }}</div>

    <div class="flex-1 min-w-0">
      <div class="flex items-center gap-1.5 min-w-0">
        <div class="text-sm text-slate-200 truncate">{{ title }}</div>
        <span v-if="badge" class="flex-shrink-0 text-[9px] uppercase tracking-wide text-cyan-200 bg-cyan-950/70 border border-cyan-800 rounded px-1 py-0.5">
          {{ badge }}
        </span>
      </div>
      <div v-if="meta && meta.length > 0" class="text-xs text-slate-500 truncate">
        {{ meta.join(' • ') }}
      </div>
    </div>

    <div
      v-if="used"
      class="flex-shrink-0 text-emerald-400"
      title="Used in design"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>

    <div
      v-if="warnings && warnings.length > 0"
      class="flex-shrink-0 text-amber-400"
      :title="warnings.join('\n')"
    >
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    </div>

    <div class="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity" @click.stop>
      <slot name="actions" />
    </div>

    <svg class="w-3.5 h-3.5 text-slate-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
    </svg>
  </div>
</template>

<script setup>
// Generic resource-list row shell — knows nothing about Datasets specifically.
// A future resource type (Theme, Font, …) reuses this same row with its own
// idLabel/title/meta/warnings and action slot.
defineProps({
  idLabel: { type: String, default: '' },
  title: { type: String, required: true },
  badge: { type: String, default: '' },
  meta: { type: Array, default: () => [] },     // muted secondary strings
  warnings: { type: Array, default: () => [] }, // shown as an amber badge + tooltip
  used: { type: Boolean, default: false },      // shown as a green "in use" badge
})

defineEmits(['select'])
</script>
